import { Component, ElementRef, OnInit } from '@angular/core';
import { BookingService, LayoutService, NavigationResolver, NavigationService } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { PageBase, TypeCategoryInfo } from 't4core';
@Component({
  selector: 'app-change-booking',
  templateUrl: './change-booking.html',
  standalone: false
})
export class ChangeBookingComponent extends PageBase implements OnInit {
  public bookingState: any;
  public loading: boolean = false;

  constructor(
    private navigator: NavigationService,
    el: ElementRef,
    private appService: AppIntegrationService,
    private bookingDataService: BookingService,
    public resolver: NavigationResolver,
    public layout: LayoutService,
    public appSettings: AppSettingsService) {
    super(el);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    const rentalIdParam = this.navigator.getParam('rentalId');
    if (rentalIdParam) {
      const rentalId = parseInt(rentalIdParam, 10);
      if (!isNaN(rentalId)) {
        // restartSession will fetch the booking and put it into the booking service state
        const ok = await this.bookingDataService.restartSession(rentalId);
        if (ok) {
          this.bookingState = this.bookingDataService.getBookingState();
          this.loading = false;
          return;
        }
      }
    }

    // fallback: use existing booking state if no param
    this.bookingState = this.bookingDataService.getBookingState();
    this.loading = false;
  }

  private startChangeBookingFlow(rentalId: number) {
    this.bookingDataService.showChangeBookingBanner(true);
    this.bookingDataService.startChangeBookingFlow(rentalId);
    this.bookingState.existingBooking = rentalId;

    if (this.bookingDataService && typeof this.bookingDataService.saveState === 'function') {
      this.bookingDataService.saveState(this.bookingState);
    }
  }

  public async changeLocation() {
    var category = await this.Api.get<TypeCategoryInfo>("RentalObject/GetFamilyForType", { objectTypeId: this.bookingState.booking.PrimaryObjectTypeId });
    this.bookingState.objectCategory = category;
    this.bookingState.specificObject = null;
    this.bookingDataService.saveState(this.bookingState);

    const rentalId = this.bookingState?.booking?.Id ?? this.bookingState?.existingBooking;
    if (!rentalId) return;

    this.startChangeBookingFlow(rentalId);
    this.navigator.executeCommand("Map", { rentalId: rentalId, changeBooking: "true" });
  }


  public async changeType() {
    this.loading = true;


    const rentalId = this.bookingState?.booking?.Id ?? this.bookingState?.existingBooking;
    if (!rentalId) return;

    this.startChangeBookingFlow(rentalId);

    this.navigator.navigateToView("ChangeBookingObject", { rentalId: rentalId, changeBooking: "true" });
  }


  public async changeTime() {
    this.loading = true;
    var category = await this.Api.get<TypeCategoryInfo>("RentalObject/GetFamilyForType", { objectTypeId: this.bookingState.booking.PrimaryObjectTypeId });
    this.bookingState.objectCategory = category;
    this.bookingDataService.saveState(this.bookingState);

    const rentalId = this.bookingState?.booking?.Id ?? this.bookingState?.existingBooking;
    if (!rentalId) return;

    this.startChangeBookingFlow(rentalId);
    this.navigator.executeCommand("DateAndTime", { rentalId: rentalId, changeBooking: "true" });
  }
}
